import { render } from "./MarketSolutions.vue?vue&type=template&id=1c665c40&scoped=true&ts=true"
import script from "./MarketSolutions.vue?vue&type=script&lang=ts"
export * from "./MarketSolutions.vue?vue&type=script&lang=ts"

import "./MarketSolutions.vue?vue&type=style&index=0&id=1c665c40&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c665c40"]])

export default __exports__